import {Component, inject, OnInit, signal} from '@angular/core';
import { MenuItem } from 'primeng/api';
import { MenuModule } from 'primeng/menu';
import {NavigationEnd, Router, RouterModule} from '@angular/router';

import { StyleClassModule } from 'primeng/styleclass';
import { LayoutService } from '../service/layout.service';
import {DocumentService} from "../../service/document.service";
import {DataService} from "../../service/data.service";
import {ProgressService} from "../../service/progress.service";
import {AppConfigurator} from "./app.configurator";
import {Tooltip} from "primeng/tooltip";

@Component({
    selector: 'app-topbar',
    standalone: true,
    imports: [RouterModule, StyleClassModule, AppConfigurator, Tooltip, MenuModule],
    templateUrl: './app.topbar.html'
})
export class AppTopbar implements OnInit {
    items!: MenuItem[];

    route = inject(Router);
    protected dataService = inject(DataService);
    protected documentService = inject(DocumentService);
    protected layoutService: LayoutService = inject(LayoutService);
    profileMenuItems!: MenuItem[];
    protected progressService = inject(ProgressService);

    protected isEditMode = signal(false);

    constructor() {
        this.route.events.subscribe(e => {
            //console.log('Event:', e);
            if (e instanceof NavigationEnd) {
                console.log('Updating editMode signal:', this.route.url.toLowerCase());
                this.isEditMode.set(this.route.url.toLowerCase().startsWith('/content'));
            }
        });
    }
    async ngOnInit() {

        this.profileMenuItems = [
            {label: 'Welcome, '+this.dataService.getScreenName(), icon: 'pi pi-fw pi-user'},
            {separator: true},
            {label: 'Profile (Coming Soon)', icon: 'pi pi-fw pi-user', command: e => this.dataService.switchToProfilePage()},
            {label: 'Report an Issue',
                icon: 'pi pi-fw pi-exclamation-circle',
                url: 'https://docs.google.com/forms/d/e/1FAIpQLSd3jTm_TAIx_j9v1m-EoQDavuBUN-UFWeKUCC2VyTlXWv7FuA/viewform?usp=pp_url&entry.960898102=RGS761542-872165',
                target: '_blank'},
            {separator: true},
            {label: 'Sign Out', icon: 'pi pi-fw pi-sign-out', command: e => this.dataService.signOut()},
        ];
    }

    toggleDarkMode() {
        this.layoutService.layoutConfig.update((state) => ({ ...state, darkTheme: !state.darkTheme }));
    }
}
